const $ = jQuery.noConflict()

class SubNav {
    constructor() {
        this.subnav = document.querySelector('.sub-navigation');
        this.subnavTrigger = document.querySelector('.sub-navigation__trigger');
		this.currentPage = document.querySelector('.sub-navigation .current-menu-item');
		this.currentPageTitle = this.currentPage ? this.currentPage.querySelector('a').textContent : '';
		this.firstMenuTitle = !this.currentPage && this.subnav && this.subnav.querySelector('.menu') ? this.subnav.querySelector('.menu a').textContent : '';
    }

    init() {
        if (this.subnav && this.subnavTrigger) {
			if(this.currentPageTitle) {
				this.subnavTrigger.textContent = this.currentPageTitle;
			} else{
				this.subnavTrigger.textContent = this.firstMenuTitle;
			}
            this.subnavTrigger.onclick = e => {
                this.triggerUndermenu();
            };
        }
    }

    triggerUndermenu() {
        if (this.subnav.classList.contains('active')) {
            this.subnav.classList.remove('active');
        } else {
            this.subnav.classList.add('active');
        }
    }
}

export default new SubNav()
